import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.financial.health.score');
import { Input } from '@angular/core';

interface FinancialHealthData {
    score?: number | null;
    raw_score?: number | null;
    status?: string;
    rating?: string;
    score_type?: string;
    score_confidence?: number;
    industry_percentile?: number | null;
    industry_position?: string;
    notice?: string;
}

@Component({
    selector: 'wiz-component-reviewops-financial-health-score',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.financial.health.score/view.scss */
.ro-health-ring {
  position: relative;
  width: 132px;
  height: 132px;
  border-radius: 50%;
}

.ro-health-ring__inner {
  position: absolute;
  inset: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 50%;
  background: #fff;
}`],
})
export class ComponentReviewopsFinancialHealthScoreComponent {
    @Input() health: FinancialHealthData = {};

    public scoreGradient(): string {
        const value = this.health.score === null || this.health.score === undefined ? 0 : this.health.score;
        return `conic-gradient(#14b8a6 0 ${value}%, #e2e8f0 ${value}% 100%)`;
    }
}

export default ComponentReviewopsFinancialHealthScoreComponent;